var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.supplierComponent,{tag:"component",attrs:{"id":_vm.id,"outFunder":_vm.isBookingFunder}})}
var staticRenderFns = []

export { render, staticRenderFns }